// Azentio Software start date (month is 1-based). Single source of truth for the
// tenure shown in the hero stats and the Experience section.
export const AZENTIO_JOINED = { year: 2025, month: 1 };

export const formatTenure = (since = AZENTIO_JOINED) => {
  const now = new Date();
  const total = (now.getFullYear() - since.year) * 12 + (now.getMonth() + 1 - since.month);
  const years = Math.floor(total / 12);
  const months = total % 12;
  const parts = [];
  if (years) parts.push(`${years} yr${years > 1 ? 's' : ''}`);
  if (months) parts.push(`${months} mo${months > 1 ? 's' : ''}`);
  return parts.join(' ') || '< 1 mo';
};
